import React from 'react';
import { IconButton } from '@mui/material';
import { AppWindow } from '@phosphor-icons/react/dist/ssr/AppWindow';

import { GeneralDrawer } from '@/types/general';

interface detailsDrawerProps {
  drawerState: GeneralDrawer;
  handleClick?: (() => void) | undefined;
}

export function DetailsDrawerCell({ ...detailsDrawerProps }: detailsDrawerProps): React.JSX.Element {
  return (
    <IconButton
      onClick={() => {
        detailsDrawerProps.handleClick?.();
      }}
    >
      <AppWindow />
    </IconButton>
  );
}
